























































import { Vue, Component, Prop } from 'vue-property-decorator';
import { State, Mutation } from 'vuex-class';
import BackgroundCheck from '~/components/UIComponents/BackgroundCheck.vue';

@Component({ components: { BackgroundCheck } })
export default class DiscordWidget extends Vue {
  @State(profile => profile.user.loggedIn, { namespace: 'profile' })
  loggedIn!: boolean;
  @State('discordLink') readonly discordLink!: string;
  @Prop(String) readonly text!: string;
  @Prop({ type: Boolean, default: true })
  readonly showBackgroundCheck!: boolean;

  @Mutation toggleDiscordDialog!: (args: any) => void;

  get defaultText() {
    return this.$t(
      'components.home.widgets.discordWidget.joinOurCommunityWidget',
    );
  }
}
